import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import axios from "axios";
// import { SiCssdesignawards } from "react-icons/si";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./testimonial.css";
import "./../style/common.css";

const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <img src="/Images/next.png" alt="Next" loading="lazy" />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <img src="/Images/pre.png" alt="Prev" loading="lazy" />
  </div>
);

const Testimonial = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await axios.get("https://cafemandhurah.mandurahcafe.com.au/api/reviews");
        setTestimonials(res.data || []);
      } catch (err) {
        console.error("Failed to fetch testimonials:", err);
      }
    };

    fetchReviews();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="testimonial-section">
      <div className="heading">
        {/* <p>
          <SiCssdesignawards /> Customer Feedback
        </p> */}
        <h2>TESTIMONIALS</h2>
      </div>
      <Slider {...settings} className="testimonial-slider">
        {testimonials.map((item, index) => (
          <div key={index} className="testimonial-card">
            <p className="testimonial-text">{item.review}</p>
            <div className="testimonial-footer">
              <img
                src={item.user_image || "/Images/default-user.png"}
                alt={item.user_name || "User"}
                className="avatar"
                loading="lazy"
              />
              <div>
                <h4>{item.user_name || "Anonymous"}</h4>
                <span>Customer</span>
              </div>
              <div className="rating">  
                {item.rating}
                <span>★</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Testimonial;
